/**
 * Feature flags for capabilities ADR-007 defers (story S11.6).
 *
 * The guardrail from S10.1 is that deferred features must be "hidden or
 * explicitly gated rather than appearing broken". QA hit the failure mode this
 * prevents: the sidebar advertised "3 messages" and led to an empty page,
 * because messaging has no backend at all.
 *
 * Flags default to OFF so a missing environment variable never exposes an
 * unfinished surface. Set REACT_APP_FEATURE_MESSAGING=true to turn messaging on
 * once story S6.1 is admitted and decision TCH-D04 is resolved.
 */

const enabled = (value: string | undefined): boolean => value === 'true';

export const features = {
  /** In-app messaging between parents and teachers — S6.1, deferred. */
  messaging: enabled(process.env.REACT_APP_FEATURE_MESSAGING),
  /** Teacher and course reviews — S6.3, deferred. */
  reviews: enabled(process.env.REACT_APP_FEATURE_REVIEWS),
} as const;

export type FeatureName = keyof typeof features;
